/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedZoomCallbackRouteImport } from './routes/_authenticated/zoom/callback'
import { Route as AuthenticatedCoursesCourseIdRouteRouteImport } from './routes/_authenticated/courses/$courseId/route'
import { Route as AuthenticatedCoursesCourseIdIndexRouteImport } from './routes/_authenticated/courses/$courseId/index'
import { Route as AuthenticatedCoursesCourseIdFeedbackConfigRouteImport } from './routes/_authenticated/courses/$courseId/feedback-config'
import { Route as AuthenticatedCoursesCourseIdFeedbackRouteImport } from './routes/_authenticated/courses/$courseId/feedback'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedZoomCallbackRoute =
  AuthenticatedZoomCallbackRouteImport.update({
    id: '/zoom/callback',
    path: '/zoom/callback',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCoursesCourseIdRouteRoute =
  AuthenticatedCoursesCourseIdRouteRouteImport.update({
    id: '/courses/$courseId',
    path: '/courses/$courseId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCoursesCourseIdIndexRoute =
  AuthenticatedCoursesCourseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCoursesCourseIdRouteRoute,
  } as any)
const AuthenticatedCoursesCourseIdFeedbackConfigRoute =
  AuthenticatedCoursesCourseIdFeedbackConfigRouteImport.update({
    id: '/feedback-config',
    path: '/feedback-config',
    getParentRoute: () => AuthenticatedCoursesCourseIdRouteRoute,
  } as any)
const AuthenticatedCoursesCourseIdFeedbackRoute =
  AuthenticatedCoursesCourseIdFeedbackRouteImport.update({
    id: '/feedback',
    path: '/feedback',
    getParentRoute: () => AuthenticatedCoursesCourseIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/sign-in': typeof SignInRoute
  '/courses/$courseId': typeof AuthenticatedCoursesCourseIdRouteRouteWithChildren
  '/zoom/callback': typeof AuthenticatedZoomCallbackRoute
  '/courses/$courseId/feedback': typeof AuthenticatedCoursesCourseIdFeedbackRoute
  '/courses/$courseId/feedback-config': typeof AuthenticatedCoursesCourseIdFeedbackConfigRoute
  '/courses/$courseId/': typeof AuthenticatedCoursesCourseIdIndexRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof SignInRoute
  '/': typeof AuthenticatedIndexRoute
  '/zoom/callback': typeof AuthenticatedZoomCallbackRoute
  '/courses/$courseId/feedback': typeof AuthenticatedCoursesCourseIdFeedbackRoute
  '/courses/$courseId/feedback-config': typeof AuthenticatedCoursesCourseIdFeedbackConfigRoute
  '/courses/$courseId': typeof AuthenticatedCoursesCourseIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/courses/$courseId': typeof AuthenticatedCoursesCourseIdRouteRouteWithChildren
  '/_authenticated/zoom/callback': typeof AuthenticatedZoomCallbackRoute
  '/_authenticated/courses/$courseId/feedback': typeof AuthenticatedCoursesCourseIdFeedbackRoute
  '/_authenticated/courses/$courseId/feedback-config': typeof AuthenticatedCoursesCourseIdFeedbackConfigRoute
  '/_authenticated/courses/$courseId/': typeof AuthenticatedCoursesCourseIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/courses/$courseId'
    | '/zoom/callback'
    | '/courses/$courseId/feedback'
    | '/courses/$courseId/feedback-config'
    | '/courses/$courseId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/'
    | '/zoom/callback'
    | '/courses/$courseId/feedback'
    | '/courses/$courseId/feedback-config'
    | '/courses/$courseId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/sign-in'
    | '/_authenticated/'
    | '/_authenticated/courses/$courseId'
    | '/_authenticated/zoom/callback'
    | '/_authenticated/courses/$courseId/feedback'
    | '/_authenticated/courses/$courseId/feedback-config'
    | '/_authenticated/courses/$courseId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/zoom/callback': {
      id: '/_authenticated/zoom/callback'
      path: '/zoom/callback'
      fullPath: '/zoom/callback'
      preLoaderRoute: typeof AuthenticatedZoomCallbackRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/courses/$courseId': {
      id: '/_authenticated/courses/$courseId'
      path: '/courses/$courseId'
      fullPath: '/courses/$courseId'
      preLoaderRoute: typeof AuthenticatedCoursesCourseIdRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/courses/$courseId/': {
      id: '/_authenticated/courses/$courseId/'
      path: '/'
      fullPath: '/courses/$courseId/'
      preLoaderRoute: typeof AuthenticatedCoursesCourseIdIndexRouteImport
      parentRoute: typeof AuthenticatedCoursesCourseIdRouteRoute
    }
    '/_authenticated/courses/$courseId/feedback-config': {
      id: '/_authenticated/courses/$courseId/feedback-config'
      path: '/feedback-config'
      fullPath: '/courses/$courseId/feedback-config'
      preLoaderRoute: typeof AuthenticatedCoursesCourseIdFeedbackConfigRouteImport
      parentRoute: typeof AuthenticatedCoursesCourseIdRouteRoute
    }
    '/_authenticated/courses/$courseId/feedback': {
      id: '/_authenticated/courses/$courseId/feedback'
      path: '/feedback'
      fullPath: '/courses/$courseId/feedback'
      preLoaderRoute: typeof AuthenticatedCoursesCourseIdFeedbackRouteImport
      parentRoute: typeof AuthenticatedCoursesCourseIdRouteRoute
    }
  }
}

interface AuthenticatedCoursesCourseIdRouteRouteChildren {
  AuthenticatedCoursesCourseIdFeedbackRoute: typeof AuthenticatedCoursesCourseIdFeedbackRoute
  AuthenticatedCoursesCourseIdFeedbackConfigRoute: typeof AuthenticatedCoursesCourseIdFeedbackConfigRoute
  AuthenticatedCoursesCourseIdIndexRoute: typeof AuthenticatedCoursesCourseIdIndexRoute
}

const AuthenticatedCoursesCourseIdRouteRouteChildren: AuthenticatedCoursesCourseIdRouteRouteChildren =
  {
    AuthenticatedCoursesCourseIdFeedbackRoute:
      AuthenticatedCoursesCourseIdFeedbackRoute,
    AuthenticatedCoursesCourseIdFeedbackConfigRoute:
      AuthenticatedCoursesCourseIdFeedbackConfigRoute,
    AuthenticatedCoursesCourseIdIndexRoute:
      AuthenticatedCoursesCourseIdIndexRoute,
  }

const AuthenticatedCoursesCourseIdRouteRouteWithChildren =
  AuthenticatedCoursesCourseIdRouteRoute._addFileChildren(
    AuthenticatedCoursesCourseIdRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCoursesCourseIdRouteRoute: typeof AuthenticatedCoursesCourseIdRouteRouteWithChildren
  AuthenticatedZoomCallbackRoute: typeof AuthenticatedZoomCallbackRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCoursesCourseIdRouteRoute:
    AuthenticatedCoursesCourseIdRouteRouteWithChildren,
  AuthenticatedZoomCallbackRoute: AuthenticatedZoomCallbackRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
